import Icon from "@mui/icons-material/VpnKey";
import TenantApiKeysCreate from "./TenantApiKeysCreate";
import TenantApiKeysEdit from "./TenantApiKeysEdit";
import { TenantApiKeysList } from "./TenantApiKeysList";

export default {
  list: TenantApiKeysList,
  create: TenantApiKeysCreate,
  edit: TenantApiKeysEdit,
  icon: Icon,
  label: "API Keys",
  options: { label: "API Keys" },
  name: "tenant-api-keys",
};
